import initWhiteInstantSearchCatalog from './containers/catalog/Catalog';
import initWhiteInstantSearchPerfectFit from './containers/catalog/PerfectFit';
import initWhiteInstantSearchSearchBar from './containers/catalog/SearchBar';

document.addEventListener('DOMContentLoaded', () => {
  initWhiteInstantSearchCatalog();
  initWhiteInstantSearchPerfectFit();
  initWhiteInstantSearchSearchBar();
});
